import React from "react";
import SubpageTitle from "../components/subpageTitle";
import Footer from "../components/footer";
import AcceptedContainersDiagram from "../images/BDImages/Group 2.svg"

export default function AcceptedContainers() {
    return (
        <div>
            <SubpageTitle title="Accepted Containers" subtitle="There are certain containers that are not covered under the NY Bottle Bill. See below the types of containers that we take and those that we don't."/>
            <div className="w-full flex justify-center">
                <img className="md:w-1/2" src={AcceptedContainersDiagram} alt="Accepted Containers Diagram"></img>
            </div>
            <Footer />
        </div>
    )
}
